import { Injectable } from '@angular/core';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { IconModel } from '../models/icon-model';

@Injectable({
  providedIn: 'root'
})
export class IconService {

  falList: IconModel[] = [];
  farList: IconModel[] = [];
  fasList: IconModel[] = [];

  list: IconModel[] = [];
  private loadPromise: Promise<IconModel[]> | null = null;

  constructor(private readonly library: FaIconLibrary) { }

  loadIcons(): Promise<IconModel[]> {
    if (!this.loadPromise) {
      this.loadPromise = this.loadIconPacks();
    }

    return this.loadPromise;
  }

  private async loadIconPacks(): Promise<IconModel[]> {
    const [lightIcons, regularIcons, solidIcons] = await Promise.all([
      import('@fortawesome/pro-light-svg-icons'),
      import('@fortawesome/pro-regular-svg-icons'),
      import('@fortawesome/pro-solid-svg-icons')
    ]);

    this.library.addIconPacks(lightIcons.fal, regularIcons.far, solidIcons.fas);

    this.falList = this.toIconList(lightIcons.fal);
    this.farList = this.toIconList(regularIcons.far);
    this.fasList = this.toIconList(solidIcons.fas);
    this.list = this.interleaveIconLists([this.falList, this.farList, this.fasList]);

    return this.list;
  }

  private toIconList(iconPack: Record<string, any>): IconModel[] {
    return Object.getOwnPropertyNames(iconPack)
      .map((propName) => iconPack[propName])
      .filter((propValue) => !!propValue?.prefix && !!propValue?.iconName)
      .map((propValue) => new IconModel(propValue.prefix, propValue.iconName));
  }

  private interleaveIconLists(iconLists: IconModel[][]): IconModel[] {
    const maxIconCount = Math.max(...iconLists.map((icons) => icons.length), 0);
    const result: IconModel[] = [];
    for (let iconIndex = 0; iconIndex < maxIconCount; iconIndex++) {
      iconLists.forEach((icons) => {
        const icon = icons[iconIndex];
        if (icon) {
          result.push(icon);
        }
      });
    }

    return result;
  }
}
